<template>
    <div class="padding7 el-card">
        <el-form label-width="120px" label-position="left">
            <div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-table
                            :data="accountTableData"
                            border
                            size="mini"
                            ref="accountTableData"
                        >
                            <el-table-column label="操作" width="80px">
                                <template slot-scope="scope">
                                    <el-tooltip content="检测" placement="top">
                                        <el-button
                                            type="info"
                                            icon="el-icon-bell"
                                            circle
                                            @click="checkStatus(scope.row)"
                                            size="mini"
                                        ></el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="name" label="账套名"></el-table-column>
                            <el-table-column prop="accountID" label="账套号"></el-table-column>
                            <el-table-column label="核算地址">
                                <template slot-scope="scope">{{
                                    scope.row.checkMethodAddr
                                }}</template>
                            </el-table-column>
                            <el-table-column label="配置参数">
                                <template slot-scope="scope">{{
                                    paramFormat(scope.row.params)
                                }}</template>
                            </el-table-column>
                            <el-table-column label="软件版本">
                                <template slot-scope="scope">
                                    <i :class="scope.row.color" style="margin-right: 10px"></i>
                                    {{ erpFormat(scope.row) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="剩余(天)">
                                <template slot-scope="scope">{{
                                    timeFormat(scope.row.startTime, scope.row.endTime)
                                }}</template>
                            </el-table-column>
                            <el-table-column label="状态">
                                <template slot-scope="scope">
                                    <i
                                        :class="statusColor(scope.row)"
                                        style="margin-right: 10px"
                                    ></i>
                                    {{ statusFormat(scope.row) }}
                                </template>
                            </el-table-column>
                        </el-table>
                        <pagerBar
                            ref="refPagerBar"
                            :apiURL="AccountListApiUrl"
                            :GetData="getTableData"
                            :queryParam="queryParam"
                            :errorFunc="closeloading"
                        ></pagerBar>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
import moment from "moment";
import config from "@/common/config.js";
import pagerBar from "@/views/pager/pagerBar";
import AjaxHelper from "@/common/js/AjaxHelper";
export default {
    data() {
        return {
            queryParam: {}, //分页查询参数
            AccountListApiUrl: config.BASE_Middle_API + "AccountConfInfosUser/GetAll",
            CheckStatusApiUrl: config.BASE_Middle_API + "apiCheck/CheckFinApiStatus",
            accountTableData: [], //账套列表数据
            selAccount: [], //选中的门店
        };
    },
    components: {
        pagerBar,
    },
    props: {
        openloading: {
            type: Function,
            required: true,
        },
        closeloading: {
            type: Function,
            required: true,
        },
        tabType: {
            type: String,
            required: true,
        },
    },
    methods: {
        checkStatus(item) {
            const _this = this;
            _this.openloading();
            const confirmData = {
                accountId: item.id,
            };
            AjaxHelper.post(_this.CheckStatusApiUrl, confirmData)
                .then(function(response) {
                    if (response.result) {
                        _this.$notify({
                            title: "提示",
                            message: "API接口状态正常",
                            type: "success",
                            position: "bottom-right",
                        });
                    } else {
                        _this.$notify({
                            title: "提示",
                            message: "API接口连接失败，请检查相关参数",
                            type: "error",
                            position: "bottom-right",
                        });
                    }
                    _this.closeloading();
                })
                .catch(function(error) {
                    _this.closeloading();
                });
        },
        getTableData(data) {
            this.accountTableData = data;
            this.closeloading();
        },
        timeFormat(start, end) {
            const nowDate = moment().format("YYYY-MM-DD"); //获取当前时间 排除时分秒 按整天
            const nowDays = moment(nowDate).diff(moment(start).format("YYYY-MM-DD"), "days");
            if (nowDays < 0) {
                const daysone = moment(end).diff(moment(start).format("YYYY-MM-DD"), "days") + 1;
                return daysone;
            } else {
                const days = moment(end).diff(new moment().format("YYYY-MM-DD"), "days") + 1;
                if (days <= 0) {
                    return "0";
                }
                return days;
            }
        },
        paramFormat(params) {
            const paramsObj = JSON.parse(params);
            let format_Str = "";
            paramsObj.forEach((x) => {
                format_Str += x.name + ":" + x.value + ",";
            });
            const reg = /,$/gi;
            format_Str = format_Str.replace(reg, "");
            return format_Str;
        },
        erpFormat(item) {
            return item.supportName + "/" + item.productName + "/" + item.versionName;
        },
        statusFormat(item) {
            const nowDate = moment().format("YYYY-MM-DD"); //获取当前时间 排除时分秒 按整天
            const nowDays = moment(nowDate).diff(
                moment(item.startTime).format("YYYY-MM-DD"),
                "days"
            );
            if (nowDays < 0) {
                return "未启用";
            } else {
                const days =
                    moment(item.endTime).diff(new moment().format("YYYY-MM-DD"), "days") + 1; //结束时间算一天 需+1
                if (days < 30 && days > 0) {
                    return "即将到期";
                } else if (days <= 0) {
                    return "过期失效";
                } else {
                    return "有效";
                }
            }
        },
        statusColor(item) {
            const nowDate = moment().format("YYYY-MM-DD"); //获取当前时间 排除时分秒 按整天
            const nowDays = moment(nowDate).diff(
                moment(item.startTime).format("YYYY-MM-DD"),
                "days"
            );
            if (nowDays < 0) {
                return "fa fa-circle el-info";
            } else {
                const days =
                    moment(item.endTime).diff(new moment().format("YYYY-MM-DD"), "days") + 1;
                if (days < 30 && days > 0) {
                    return "fa fa-circle el-warning";
                } else if (days <= 0) {
                    return "fa fa-circle el-danger";
                } else {
                    return "fa fa-circle el-success";
                }
            }
        },
    },
};
</script>

<style scoped="scoped">
.minicard {
    height: auto !important;
    display: block;
    width: 200px;
    position: absolute;
    right: 0;
    z-index: 9989;
    top: 80px;
}
.minicard .el-button {
    width: 150px;
    margin: 5px 0;
}
.el-dialog__body {
    padding: 10px 15px !important;
}

dl.loglist p {
    font-weight: 600;
    margin: 20px 0 10px 0;
}
dl.loglist dd {
    padding: 15px 0;
    color: #999999;
    display: block;
}
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}
.w25 {
    width: 25%;
    float: left;
}
.w75 {
    width: 75%;
    float: left;
}
.el-card {
    border: 0;
    height: calc(100vh - 225px);
    overflow-y: auto;
}
.padding7 {
    padding: 7px;
}
.top5 {
    padding: 5px 0 0 0;
}
.top7 {
    padding: 7px 0 0 0;
}
</style>
